import { LinkExpirationType, LinkAuthenticationType} from './link';

// explicitly specify values to ensure bitfield 
export enum GroupSharePermissions {
	None						= 0,
	ReshareInternally			= 1 << 0,
	ReshareExternallyView		= 1 << 1,
	ReshareExternallyEdit		= 1 << 2,
	GrantDownloadExternally		= 1 << 3,
	GrantUploadExternally		= 1 << 4,
	GrantListContentsExternally	= 1 << 5,
	GrantDeleteInternally		= 1 << 6,
}

export enum GroupShareTriState {
	No,
	Yes,
	Never
}

export interface UserGroupPolicy {
	AllowPrivileges: number;
	DenyPrivileges: number;
	AreSharingPermissionsSet: boolean;
	MaxLinkExpirationDays: string | number;
	MaxLinkExpirationType: LinkExpirationType;
	MinLinkAuthenticationType: LinkAuthenticationType;
	UserGroupId: number;
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/user-group.ts